import {BaseService} from './base.service';
import {IBlock, BlockDto, IBlockParameter} from '../models/block';
import {BlockListingViewModel} from '../models/block/block-listing.viewmodel';
import {Uris} from '../common/constants';
import * as JSONPatch from "fast-json-patch";
import { AddressDto } from '../models/address/address.model';

export interface IBlockService {

  initBlock(opts?: IBlock) : IBlock

  recordBlock(block: IBlock ) : Promise<any>

  updateBlock(blockId: number, block: IBlock ) : Promise<any>

  deleteBlock(blockId: number ) : Promise<any>

  getBlocks (params: IBlockParameter, allowPagination?: boolean): Promise<any>

  getBlockById (blockId: string): Promise<any>

  getBlockDashboardById (blockId: string): Promise<any>

  getBlockDetailStatistic (blockId: string, fromDate: string, toDate: string): Promise<any>

  getBlockByTenantId (tenantId: number): Promise<any>
}

export class BlockService extends BaseService implements IBlockService {
  blockParameter: IBlockParameter;

  /**
   *
   */
  constructor () {
    super();
  }

  public initBlock(opts?: IBlock): IBlock {
    return new BlockDto(
      opts ? opts: {
        managers: [],
        address: new AddressDto
    })
  }

  public recordBlock(block: IBlock ): Promise<any> {
      return this.cookBlock(block)
         .then( cookedblock =>{
          return super.post(Uris.Block, { ...cookedblock })
              .then(createdBlock => Promise.resolve(createdBlock))
              .catch(error => Promise.reject(error));
        })
  }

  public updateBlock(blockId: number, block: IBlock) : Promise<any> {
     return this.cookBlock(block,'update')
            .then( cookedBlock => {
                return super.patch(`${Uris.Block}/${blockId}`,{ ...cookedBlock })
                    .then( updatedBlock => Promise.resolve(updatedBlock))
                    .catch( error => Promise.reject(error) )
            })
  }

  public deleteBlock(blockId: number) : Promise<any> {
     return super.delete(`${Uris.Block}/${blockId}`)
            .then( deletedBlock => Promise.resolve(deletedBlock))
            .catch(error => Promise.reject(error))
  }

  public cookBlock(block: IBlock, task: string = 'create' ) : Promise<IBlock> {

    const { countryCode, iris_code, ...address } = block.address

    let cookedBlock: any = {
      name: block.name,
      ... block.address.isNotEmpty() && { address },
      picture: block.attachment || '',
      relations: {
        managers: block.managers,
        caretakers: block.concierge || [] ,
        salespersons: block.commercial || []
      }
    }

    if(task === 'create'){
      cookedBlock = {
        ...cookedBlock,
        digicode: block.digicode || '',
        number_apartments: block.nbreLots || null
      }
    }

    return Promise.resolve(cookedBlock)
  }

  getBlocks (params: IBlockParameter, allowPagination?: boolean) {
    let cookedParameter = JSON.parse(JSON.stringify(params));

    if (!this.blockParameter) {
      this.blockParameter = cookedParameter;
    } else {

      const changes = JSONPatch.compare(this.blockParameter, cookedParameter);
      const orderChanges = changes.find(x => x.path.indexOf('order') > -1)
      if (orderChanges) {
        const paths: string[] = orderChanges.path.split('/')
        const index: number = Number(paths[paths.length - 1]);
        this.blockParameter = cookedParameter;
        // Index = NaN when got to ticket list from block page
        if (index) {
          cookedParameter = {
            ...cookedParameter,
            orderKeys: [cookedParameter.orderKeys[index]],
            orderValues: [cookedParameter.orderValues[index]]
          }
        }
      }
    }
    //cookedParameter.$limit = 50
    if (cookedParameter.key) {

      if (params.key && params.key.length > 0) {
        cookedParameter.key = params.key.replace('#', '')
      }
    }

    return super.get(Uris.Block, cookedParameter)
      .then((result: any) => {
        if (allowPagination) {
          return Promise.resolve(result);
        }
        return Promise.resolve(result.data.map((block: IBlock) => this.mapBlockModelToBlock(block).next().value));
      })
      .catch(error => {
        console.log(error, 'getBlocks');
        return Promise.reject(error)
      })
  }

  getBlockById (id: string) {
    return super.get(Uris.BlockId.replace(':id', id))
      .then((result: any) => {
        return new BlockListingViewModel(result);
      })
      .catch(error => console.log(error))
  }

  getBlockDashboardById (id: string) {
    return super.get(Uris.BlockIdDashboard.replace(':id', id))
      .then((result: any) => result)
      .catch(error => Promise.reject(error))
  }

  getBlockDetailStatistic (blockId: string, fromDate: string, toDate: string) {
    return super.get(Uris.BlockStatistic.replace(':id', blockId), {start: fromDate, end: toDate})
      .then((result: any) => result)
      .catch(error => console.log(error))
  }

  async getBlockByTenantId (id: number) {

    const response: any = await super.get(Uris.Block, {
      entity: id,
      $limit: Number.MAX_SAFE_INTEGER
    })

    return {
      blocks: response.data
    }
  }

  * mapBlockModelToBlock (entity: IBlock) {
    yield new BlockListingViewModel(entity);
  }
}



// WEBPACK FOOTER //
// ./src/services/block.service.ts